// extracted by mini-css-extract-plugin
module.exports = {"title":"OtherVenuesStyles_title__3tLmL","venues_list":"OtherVenuesStyles_venues_list__3Fae7","venues_item":"OtherVenuesStyles_venues_item__1gEBg"};